import { financeNames } from "../../constants";
import { ERRORS_TYPE, regularErrorScreenGifIcon, islamicErrorScreenGifIcon } from "./constants";

export const getErrorScreensIcons = (
  financeType = financeNames.businessFinance,
  isIslamicBanking = false,
  screeningType = ERRORS_TYPE.DEDUPE
) => {
  if (isIslamicBanking) {
    return islamicErrorScreenGifIcon[screeningType];
  }
  return regularErrorScreenGifIcon[screeningType];
};
